import React, { useState, useEffect } from 'react'
import { Container } from "@bsf/force-ui";
import Sidebar from './Sidebar';
import Content from './Content';
import NavMenu from '@components/NavMenu';
import HeaderLine from '@components/HeaderLine';
import ThemeSupport from './ThemeSupport';
import VersionControl from './VersionControl';
import MyAccount from './MyAccount';
import Integrations from './Integrations';
import Branding from './Branding';
import PostSkins from './PostSkins';
import { __ } from '@wordpress/i18n';

const Settings = () => {
    const items = [
        {
            id: 1,
            icon: (
                <img
                    src={`${uaelSettingsData.user_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            selected: (
                <img
                    src={`${uaelSettingsData.user__selected_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            title: __('My Account', 'uael'),
            content: <MyAccount />
        },
        {
            id: 2,
            icon: (
                <img
                    src={`${uaelSettingsData.theme_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            selected: (
                <img
                    src={`${uaelSettingsData.theme__selected_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            main: __('Editor', 'uael'),
            title: __('Theme Support', 'uael'),
            content: <ThemeSupport />
        },
        {
            id: 3,
            icon: (
                <img
                    src={`${uaelSettingsData.version_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            selected: (
                <img
                    src={`${uaelSettingsData.version__selected_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            main: __('Utilities', 'uael'),
            title:  __('Version Control', 'uael'),
            content: <VersionControl />
        },
        {
            id: 4,
            icon: (
                <img
                    src={`${uaelSettingsData.branding_url}`}
                    alt="Custom SVG"
                    className="object-contain"

                />
            ),
            selected: (
                <img
                    src={`${uaelSettingsData.branding__selected_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            main: '',
            title: __('White Label', 'uael'),
            content: <Branding />
        },
        {
            id: 5,
            icon: (
                <img
                    src={`${uaelSettingsData.integrations_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            selected: (
                <img
                    src={`${uaelSettingsData.integrations__selected_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            main: __('Preferences', 'uael'),
            title: __('Integrations', 'uael'),
            content: <Integrations />
        },
        {
            id: 6,
            icon: (
                <img
                    src={`${uaelSettingsData.postskins_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            selected: (
                <img
                    src={`${uaelSettingsData.postskins_selected_url}`}
                    alt="Custom SVG"
                    className="object-contain"
                />
            ),
            main: __('Skins', 'uael'),
            title: __('Post Widget Skins', 'uael'),
            content: <PostSkins />
        }
    ].filter(item => {
        if ( ( 'no' === uaelSettingsData.show_theme_support ) && item.id === 2 ) {
            return false;
        }

        if (uaelSettingsData.hide_settings) {
            return item.id !== 3 && item.id !== 4;
        }

        return true;
    });

    // Default state: Set 'My Account' (first item) as the default when the settings tab is clicked
    const [selectedItem, setSelectedItem] = useState(() => {
        const savedItemId = localStorage.getItem('selectedItemId');
        const savedItem = items.find(item => item.id === Number(savedItemId));
        return savedItem || items[0]; // Default to the first item if no saved item is found
    });

    useEffect(() => {
        // Store selectedItemId in localStorage (or other persistent storage) to retain selection
        localStorage.setItem('selectedItemId', selectedItem.id.toString());
    }, [selectedItem]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tab = params.get('tab');
        if (tab) {
            const itemId = Number(tab);
            const item = items.find(item => item.id === itemId);
            if (item) {
                setSelectedItem(item);
            }
        }
    }, []);

    const handleSelectItem = (item) => {
        setSelectedItem(item);
    };

    const handleSettingsTabClick = () => {
        setSelectedItem(items[0]); // Set "My Account" as the default item when settings tab is clicked
    };

    return (
        <>
            <NavMenu onSettingsTabClick={handleSettingsTabClick} /> {/* Ensure Settings tab triggers this */}
            <div>
                <HeaderLine />
                <Container align="stretch" className="p-1 flex-col lg:flex-row uae-settings-page" containerType="flex" direction="row" gap="sm" justify="start" style={{ height: "100%" }}>
                    <Container.Item className="p-2 uae-sticky-outer-wrapper" alignSelf="auto" order="none" shrink={1} style={{ backgroundColor: "#ffffff" }}>
                        <div className='uae-sticky-sidebar'>
                            <Sidebar items={items} onSelectItem={handleSelectItem} selectedItemId={selectedItem.id} />
                        </div>
                    </Container.Item>
                    <Container.Item className="p-2 flex w-full justify-center items-start uae-hide-scrollbar" alignSelf="auto" order="none" shrink={1} style={{ height: "calc(100vh - 1px)", overflowY: "auto" }}>
                        <div className="uael-78-width">
                            <Content selectedItem={selectedItem} />
                        </div>
                    </Container.Item>
                </Container>
            </div>
        </>
    );
};

export default Settings;